export function isWriteOnlySchema(schema) {
    const stringified = JSON.stringify(schema);
    return stringified?.includes('writeOnly');
}
